import { render, staticRenderFns } from "./DataPolicy.vue?vue&type=template&id=4f515ed6&scoped=true"
import script from "./DataPolicy.vue?vue&type=script&lang=ts"
export * from "./DataPolicy.vue?vue&type=script&lang=ts"
import style0 from "./DataPolicy.vue?vue&type=style&index=0&id=4f515ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f515ed6",
  null
  
)

export default component.exports